<template>
    <div class="form-group mt-2">
        <label class="form-label" for="payment_online">
            Співробітник
        </label>
        <div class="" v-if="draw_items.length > 0">
            <v-select
                v-model="active_dep_id"
                id="users_list"
                class="imc_reasons"
                :reduce="item => item.id"
                label="name"
                :options="this.draw_items"
                :searchable="true"
                :filterable="true"
            >
                <template slot="no-options">
                    Оберіть організацію
                </template>
                
                
                <template v-slot:option="option">
                    <div class="pt-2 pb-2">
                        <div class='icon-stack fs-xl mr-3'>
                            <i class="base base-19 icon-stack-3x opacity-100 color-primary-500"></i>
                            <i class="base base-2 icon-stack-2x opacity-100 color-primary-300"></i>
                            <i class="fas fa-arrow-right icon-stack-1x opacity-100 color-white"></i>
                        </div>
                        <span class="imc_opt">
                              {{ option.name }}
                        </span>
                    </div>
                
                </template>
            </v-select>
        </div>
    </div>
</template>


<script>
import vSelect from 'vue-select';
export default {
    name: "users_select",
    components : {
        vSelect
    },
    data() {
        return {
            is_load: false,
            items : [],
            current_item : null,
        }
    },
    
    props : {
        active_id : {
            type : Number,
            required : true
        },
    },
    
    created () {
        this.load_items();
    },
    
    methods : {
        async load_items() {
            this.items = [];
            await api.get('/users/simple').then(({data}) => {
                this.is_load = true;
                if(data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                this.is_load = false;
            });
        },
    },
    
    computed : {
        draw_items() {
            return this.items;
        },
        
        active_dep_id : {
            get() {
                if(parseInt(this.active_id) > 0) {
                    return this.active_id;
                }
                return null;
            },
            set(new_id) {
                this.$emit('on_item_set',new_id);
            }
        },
    }
}
</script>



<style scoped>

</style>